import * as Yup from "yup";
import {ConvertPersianToEnglish} from "../helpers/convertor";

const isMobile = (value: string) => {

    const regex = new RegExp('^(\\+98|0)?9\\d{9}$');
    return regex.test(value);
}
const isDigit = (value: string) => {

    return !isNaN(+value)
}
const isTelephone = (value: string) => {
    const regex = new RegExp('^0[1-8]{2,}[0-9]{8,}$');

    return regex.test(value);
}
const mobileValidation = Yup.string().test(
    'is-mobile',
    " تلفن همراه نامعتبر می باشد.",
    (value) => isMobile(ConvertPersianToEnglish(value + "") + ""),
).required(' تلفن همراه الزامی می باشد.');
const digitsValidation = Yup.string().test(
    'digits',
    "رقم فعلی  کنتور نا معتبر می باشد.",
    (value) => isDigit(ConvertPersianToEnglish(value + "") + ""),
).required(' تلفن همراه الزامی می باشد.');
const telephoneValidation = Yup.string().test(
    'is-telephone',
    " تلفن نامعتبر می باشد.",
    (value) => isTelephone(ConvertPersianToEnglish(value + "") + ""),
).required('تلفن  الزامی می باشد.').max(11, 'تلفن حداکثر ۱۱ رقم می باشد');

const RequestActivationCodeValidation = Yup.object().shape({

    mobile: mobileValidation,
    name: Yup.string().required('نام الزامی می باشد').min(3, 'نام حداقل ۳ حرف دارد'),
    activationCode: Yup.string().min(4, 'کد تایید حداقل ۴ رقم دارد').required('کد تایید الزامی می باشد.')
});
const defaultValidation = {
    email: Yup.string().email(' ایمیل اشتباه می باشد'),
    description: Yup.string().max(100, 'توضیحات باید کمتر از ۱۰۰ حرف باشد'),
    postalCode: Yup.string().required('کد پستی الزامی می باشد').min(10, 'کد پستی ۱۰ رقم می باشد').max(10, 'کد پستی ۱۰ رقم می باشد'),
    tel: telephoneValidation,
    mobile: mobileValidation,
    firstName: Yup.string().required(' نام الزامی می باشد.').min(2, 'نام حداقل ۲ حرف می باشد').max(100, 'نام حداکثر ۱۰۰ حرف  می باشد'),
    lastName: Yup.string().required(' نام خانوادگی الزامی می باشد.').min(2, 'نام خانوادگی حداقل ۲ حرف می باشد').max(100, ' نام خانوادگی حداکثر ۱۰۰ حرف  می باشد'),
    nationalCode: Yup.string().required('کد ملی الزامی می باشد').min(10, 'کد ملی ۱۰ رقم می باشد').max(10, 'کد ملی ۱۰ رقم می باشد'),
    address: Yup.string().max(100, 'آدرس باید کمتر از ۱۰۰ حرف باشد')
}
const ReplyToInquiryValidation = Yup.object().shape({
    ...defaultValidation
});
const GetWorkFlowValidation = Yup.object().shape({
    billId: Yup.string().required('شناسه قبض الزامی می باشد').min(5, 'شناسه قبض حداقل ۵ رقم می باشد.'),
    traceNumber: Yup.string().required(' کد رهگیری الزامی می باشد.').min(5, 'کد رهگیری ۵ رقم می باشد'),
});
const MoveMeasuringDevicesValidation = Yup.object().shape({
    ...defaultValidation
});
const InstallAdditionalSiphoneValidation = Yup.object().shape({
    ...defaultValidation
});
const MeterTestValidation = Yup.object().shape({
    ...defaultValidation
});
const MeterChangeValidation = Yup.object().shape({
    ...defaultValidation
});
const CollectOrMergeBranchValidation = Yup.object().shape({
    ...defaultValidation
});
const TemporaryDisconnectAndConnectBranchValidation = Yup.object().shape({
    ...defaultValidation
});
const ChangeSpecificationsValidation = Yup.object().shape({
    ...defaultValidation,
    newFirstName: Yup.string().required(' نام الزامی می باشد.').min(2, 'نام حداقل ۲ حرف می باشد').max(100, 'نام حداکثر ۱۰۰ حرف  می باشد'),
    newLastName: Yup.string().required(' نام خانوادگی الزامی می باشد.').min(2, 'نام خانوادگی حداقل ۲ حرف می باشد').max(100, ' نام خانوادگی حداکثر ۱۰۰ حرف  می باشد'),
    businessNumber: Yup.string().max(100, 'کد اقتصادی حداکثر 100 کاراکتر می باشد.')
});
const BillingReviewValidation = Yup.object().shape({
    ...defaultValidation
});
const WasteWaterBranchAssignmentValidation = Yup.object().shape({
    ...defaultValidation,
    newAddress: Yup.string().max(100, 'آدرس باید کمتر از ۱۰۰ حرف باشد').required('فیلد آدرس الزامی می باشد.'),

});
const MeterSeparationValidation = Yup.object().shape({
    ...defaultValidation,
    address: Yup.string().max(100, 'آدرس باید کمتر از ۱۰۰ حرف باشد').required('فیلد آدرس الزامی می باشد.'),

});

const WaterBranchAssignmentValidation = Yup.object().shape({
    email: Yup.string().email(' ایمیل اشتباه می باشد'),

    description: Yup.string().max(100, 'توضیحات باید کمتر از ۱۰۰ حرف باشد'),
    postalCode: Yup.string().required('کد پستی الزامی می باشد').min(10, 'کد پستی ۱۰ رقم می باشد').max(10, 'کد پستی ۱۰ رقم می باشد'),
    tel: telephoneValidation,
    mobile: mobileValidation,
    firstName: Yup.string().required(' نام الزامی می باشد.').min(2, 'نام حداقل ۲ حرف می باشد').max(100, 'نام حداکثر ۱۰۰ حرف  می باشد'),
    lastName: Yup.string().required(' نام خانوادگی الزامی می باشد.').min(2, 'نام خانوادگی حداقل ۲ حرف می باشد').max(100, ' نام خانوادگی حداکثر ۱۰۰ حرف  می باشد'),
    nationalCode: Yup.string().required('کد ملی الزامی می باشد').min(10, 'کد ملی ۱۰ رقم می باشد').max(10, 'کد ملی ۱۰ رقم می باشد'),
});
const ChangeAccountTypeValidation = Yup.object().shape({
    ...defaultValidation
});
const ChangeUnitValidation = Yup.object().shape({
    ...defaultValidation,
    NewUnit: Yup.number().typeError('تعداد واحد باید عددی باشد').positive('تعداد واحد باید بزرگ تر از ۰ باشد باشد'),
    CurrentUnit: Yup.number().typeError('تعداد واحد باید عددی باشد').positive('تعداد واحد باید بزرگ تر از ۰ باشد باشد').required(' تعداد واحد الزامی می باشد'),
});
const AddBranchValidation = Yup.object().shape({
    FileNumber: Yup.string().required('شناسه قبض الزامی می باشد.').min(4, 'شناسه قبض حداقل ۴ رقم می باشد').max(20, 'شناسه قبض ۲۰ رقم می باشد'),

});
const EditNameValidation = Yup.object().shape({
    Name: Yup.string().required('نام مستعار الزامی می باشد.').max(30, 'نام مستعار ۳۰ حرف می باشد'),

});
const ChangeCapacityContractualBranchingValidation = Yup.object().shape({
    ...defaultValidation,
    NewCapacity: Yup.number().typeError('تعداد واحد باید عددی باشد').positive('تعداد واحد باید بزرگ تر از ۰ باشد باشد')/*.required(' تعداد واحد الزامی می باشد')*/,
    CurrentCapacity: Yup.number().typeError('تعداد واحد باید عددی باشد').required(' تعداد واحد الزامی می باشد'),
});
const ChangeBranchDiameterValidation = Yup.object().shape({
    ...defaultValidation,
    currentBranchDiameter: Yup.string().required(' قطر انشعاب قبلی الزامی می باشد'),
    NewBranchDiameter: Yup.number().typeError('قطر انشعاب جدید باید عددی باشد')/*.required('قطر انشعاب جدید الزامی می باشد')*/,
});
const DeclareMeterConsumptionValidation = Yup.object().shape({
    ...defaultValidation,
    activeNowNumber: digitsValidation.required(' رقم فعلی الزامی می باشد'),
});
const MidTermBillValidation = Yup.object().shape({
    ...defaultValidation,
    PreviousMeterNumber: Yup.number().typeError('شماره فعلی کنتور باید عددی باشد').positive('شماره فعلی کنتور باید عددی مثبت باشد').required('شماره فعلی کنتور الزامی می باشد'),
    CurrentMeterNumber: Yup.number().typeError('شماره جدید کنتور باید عددی باشد').positive('شماره جدید کنتور باید عددی مثبت باشد').required('شماره جدید کنتور الزامی می باشد'),
});
const SaleTankerWaterValidation = Yup.object().shape({
    ...defaultValidation,
    address: Yup.string().required('آدرس الزامی می‌باشد').max(100, 'آدرس باید کمتر از ۱۰۰ حرف باشد'),
    WaterVolume: Yup.number().typeError('حجم آب فعلی کنتور باید عددی باشد').positive('حجم آب   باید عددی مثبت باشد').required('حجم آب الزامی می باشد'),
});
const Validation = (schema: any) => {
    return {
        async validator({field}: any, value: any) {
            await schema.validateSyncAt(field, {[field]: value});
        },
    };
}
export {
    Validation,
    AddBranchValidation, InstallAdditionalSiphoneValidation,
    RequestActivationCodeValidation,
    ReplyToInquiryValidation,
    TemporaryDisconnectAndConnectBranchValidation,
    MeterTestValidation,
    ChangeSpecificationsValidation,
    BillingReviewValidation,
    DeclareMeterConsumptionValidation,
    WasteWaterBranchAssignmentValidation,
    ChangeUnitValidation,
    ChangeCapacityContractualBranchingValidation,
    ChangeBranchDiameterValidation,
    SaleTankerWaterValidation,
    MoveMeasuringDevicesValidation,
    CollectOrMergeBranchValidation,
    MeterChangeValidation,
    MidTermBillValidation,
    ChangeAccountTypeValidation,
    WaterBranchAssignmentValidation,
    EditNameValidation,
    MeterSeparationValidation,
    GetWorkFlowValidation
}